<template>
  <div>
    <material-button
      class="d-none show-modal-connect-qlub"
      data-bs-toggle="modal"
      data-bs-target="#connectQlub"
    ></material-button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="connectQlub"
      tabindex="-1"
      aria-hidden="true"
      style="z-index: 1056"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Connect Qlub
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body" style="overflow-y: unset">
            <!-- Qlub issues a restaurant slug and a redirect key per
                 restaurant; they are one pair. The secret Qlub uses to call
                 us identifies MegaPOS, so it lives in the ordering API's .env
                 and is never asked for here. -->
            <div class="group-option-list">
              <label class="fw-bold" for
                >Restaurant Slug <span class="text-danger ms-2">*</span></label
              >
              <material-input
                v-model="restaurant_slug"
                type="text"
                id="qlub_restaurant_slug"
                name="qlub_restaurant_slug"
              />
            </div>
            <div class="group-option-list mt-3">
              <label class="fw-bold" for
                >Redirect Key <span class="text-danger ms-2">*</span></label
              >
              <material-input
                v-model="redirect_key"
                type="text"
                id="qlub_redirect_key"
                name="qlub_redirect_key"
              />
            </div>
            <div class="mt-3 text-muted text-sm">
              <template v-if="type == 2">
                Leave both empty to use the merchant's Qlub restaurant.
              </template>
              <template v-else>
                Used by every physical branch without its own Qlub restaurant.
              </template>
              Set the outlet's MOO Payment Mode to Qlub in Store settings.
            </div>
            <div
              class="mt-3 text-danger"
              style="word-break: break-all"
              v-if="messageErr"
            >
              {{ messageErr }}
            </div>
            <div class="d-flex justify-content-end mt-5">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="connect()"
              >
                Save
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background btn-cancel-qlub"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </material-button>
            </div>
          </div>
        </div>
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import PaymentService from "@/services/payment.service";
import $ from "jquery";

export default {
  name: "connect-qlub",
  components: {
    MaterialLoading,
    MaterialSnackbar,
    MaterialButton,
    MaterialInput,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    physicalBranchId: {
      type: Number,
      required: true,
    },
    restaurantSlugSelected: {
      type: String,
      default: '',
    },
    redirectKeySelected: {
      type: String,
      default: '',
    },
    getList: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      restaurant_slug: "",
      redirect_key: "",
      messageErr: "",
    };
  },
  methods: {
    connect() {
      const slug = (this.restaurant_slug || "").trim();
      const key = (this.redirect_key || "").trim();

      // A branch may clear both to fall back to the merchant; the merchant
      // itself needs a pair.
      if ((!slug || !key) && !(this.type == 2 && !slug && !key)) {
        this.messageErr = "Restaurant slug and redirect key are required";
        return;
      }

      this.showLoader();
      let dataForm = {
        type: this.type,
        physical_branch_id: this.physicalBranchId,
        restaurant_slug: slug,
        redirect_key: key,
      };

      PaymentService.connectQlub(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            $(".btn-cancel-qlub").click();
            this.snackbar = "success";
            this.message = "Saved Successfully!";
            this.setTimeOutNotification();
            this.getList(1);
          } else {
            this.messageErr = response.data.result.message;
          }
          this.hideLoader();
        },
        (error) => {
          this.messageErr = error.response.data.result.message;
          this.hideLoader();
        }
      );
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.restaurant_slug = this.restaurantSlugSelected;
      this.redirect_key = this.redirectKeySelected;
      this.messageErr = "";
    },
  },
};
</script>
